const StoneberryCreditIcon = () => {
  return (
    <>
      <svg width="254" height="32" viewBox="0 0 254 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_858_15980)">
          <path d="M24.2036 15.9295L15.2323 25.3159L6.26172 15.9295L15.2323 6.54382L24.2036 15.9295Z" fill="#113050" />
          <path d="M24.2037 15.9295L25.4149 22.4631L16.4441 31.8495L15.2324 25.3159L24.2037 15.9295Z" fill="#76C6B3" />
          <path
            d="M14.0143 -0.000244141L5.04297 9.38617L6.26155 15.93L15.2328 6.54357L14.0143 -0.000244141Z"
            fill="#0075C9"
          />
          <path d="M0 17.2044L8.97129 26.5908L15.2324 25.3157L6.26161 15.93L0 17.2044Z" fill="#F2B5B6" />
          <path d="M15.2324 6.54356L21.4864 5.27643L30.4577 14.6621L24.2037 15.93L15.2324 6.54356Z" fill="#F8BA17" />
          <mask
            id="mask0_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_858_15980)">
            <path
              d="M41.4378 14.9075L41.2887 14.8798C39.4607 14.5418 37.8812 14.2495 37.8812 12.6521C37.8812 11.1321 39.0775 10.1497 40.93 10.1497C42.7064 10.1497 43.8559 11.0823 43.9298 12.5836L43.9367 12.718H46.5656L46.5609 12.5712C46.4608 9.52163 44.1786 7.47321 40.8815 7.47321C37.4985 7.47321 35.2259 9.58558 35.2259 12.7292C35.2259 16.5712 38.0972 17.1013 40.6303 17.5687L40.7748 17.5952C42.5984 17.9327 44.1725 18.2243 44.1725 19.825C44.1725 21.4246 42.9328 22.3792 40.8561 22.3792C38.8584 22.3792 37.6364 21.4229 37.5886 19.8209L37.5847 19.683H34.8574L34.8609 19.8289C34.9343 23.0032 37.2877 25.0557 40.8561 25.0557C44.5133 25.0557 46.8765 22.9728 46.8765 19.7494C46.877 15.9018 43.9869 15.3739 41.4378 14.9075Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask1_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_858_15980)">
            <path
              d="M66.3029 11.5435C62.476 11.5435 59.6992 14.3849 59.6992 18.2999C59.6992 22.2141 62.476 25.0562 66.3029 25.0562C70.1285 25.0562 72.906 22.2141 72.906 18.2999C72.906 14.3852 70.1288 11.5435 66.3029 11.5435ZM70.2994 18.2999C70.2994 20.7914 68.6558 22.5329 66.3029 22.5329C63.9494 22.5329 62.3058 20.7914 62.3058 18.2999C62.3058 15.8077 63.9494 14.0669 66.3029 14.0669C68.6558 14.0669 70.2994 15.8077 70.2994 18.2999Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask2_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_858_15980)">
            <path
              d="M80.5472 11.5435C76.747 11.5435 74.4785 13.974 74.4785 18.0448V24.7248H77.0606V18.0448C77.0606 15.5171 78.3316 14.0674 80.5472 14.0674C82.7628 14.0674 84.0338 15.5171 84.0338 18.0448V24.7248H86.6154V18.0448C86.6154 13.974 84.3474 11.5435 80.5472 11.5435Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask3_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask3_858_15980)">
            <path
              d="M94.7907 11.5433C90.9643 11.5433 88.1875 14.3847 88.1875 18.3001C88.1875 22.2144 90.9643 25.0565 94.7907 25.0565C97.5975 25.0565 99.8538 23.5875 100.825 21.1269L100.902 20.9297H98.0738L98.0329 20.9929C97.3556 22.0427 96.3256 22.5327 94.7904 22.5327C92.7558 22.5327 91.285 21.3112 90.9168 19.3324H101.346V18.3001C101.346 14.3847 98.5896 11.5433 94.7907 11.5433ZM91.0047 16.8854C91.4885 15.1161 92.8914 14.0671 94.7907 14.0671C96.711 14.0671 98.123 15.1169 98.6016 16.8854H91.0047Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask4_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask4_858_15980)">
            <path
              d="M123.652 11.5433C119.826 11.5433 117.049 14.3847 117.049 18.3001C117.049 22.2144 119.826 25.0565 123.652 25.0565C126.459 25.0565 128.715 23.5875 129.686 21.1269L129.764 20.9297H126.935L126.894 20.9929C126.217 22.0427 125.187 22.5327 123.652 22.5327C121.617 22.5327 120.147 21.3112 119.778 19.3324H130.207V18.3001C130.207 14.3847 127.45 11.5433 123.652 11.5433ZM119.866 16.8854C120.35 15.1161 121.753 14.0671 123.652 14.0671C125.572 14.0671 126.984 15.1169 127.463 16.8854H119.866Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask5_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask5_858_15980)">
            <path
              d="M137.092 11.5435C133.714 11.5435 131.777 13.5983 131.777 17.1801V24.7248H134.359V17.1799C134.359 15.1144 135.278 14.0671 137.092 14.0671C138.879 14.0671 139.824 15.1434 139.824 17.1799V17.4756H142.383V17.2059C142.383 13.607 140.454 11.5435 137.092 11.5435Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask6_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask6_858_15980)">
            <path
              d="M148.842 11.5435C145.464 11.5435 143.527 13.5983 143.527 17.1801V24.7248H146.109V17.1799C146.109 15.1144 147.029 14.0671 148.842 14.0671C150.629 14.0671 151.575 15.1434 151.575 17.1799V17.4756H154.132V17.2059C154.132 13.607 152.204 11.5435 148.842 11.5435Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask7_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask7_858_15980)">
            <path
              d="M164.83 11.8742V18.4523C164.83 20.927 163.527 22.405 161.344 22.405C159.128 22.405 157.857 20.9642 157.857 18.4523V11.8742H155.275V18.4523C155.275 23.2461 158.209 24.9543 160.955 24.9543C162.622 24.9543 164.008 24.2207 164.83 22.9229V25.6333C164.83 28.2074 163.674 29.4587 161.295 29.4587C159.568 29.4587 158.472 28.8053 157.944 27.4611L157.91 27.3729H155.333L155.377 27.5509C156.054 30.286 158.211 31.8551 161.295 31.8551C165.183 31.8551 167.412 29.5681 167.412 25.5822V11.8742H164.83Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask8_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask8_858_15980)">
            <path
              d="M109.734 11.5637C107.888 11.5637 106.335 12.3567 105.397 13.7563V6.19949L102.814 8.9013V18.2182C102.814 22.3201 105.439 25.0766 109.345 25.0766C113.247 25.0766 115.972 22.2669 115.972 18.2435C115.972 13.8585 112.835 11.5637 109.734 11.5637ZM109.369 22.5528C107.031 22.5528 105.397 20.8125 105.397 18.3198C105.397 15.8283 107.031 14.0873 109.369 14.0873C111.723 14.0873 113.366 15.8281 113.366 18.3198C113.366 20.8125 111.723 22.5528 109.369 22.5528Z"
              fill="#113050"
            />
          </g>
          <mask
            id="mask9_858_15980"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="168"
            height="43"
          >
            <path d="M167.413 0H0V42.257H167.413V0Z" fill="white" />
          </mask>
          <g mask="url(#mask9_858_15980)">
            <path
              d="M56.0906 19.826C56.0906 21.5969 55.2638 22.5324 53.6985 22.5324C52.1494 22.5324 51.3304 21.5969 51.3304 19.826V14.372H56.3634V11.8742H51.3304V7.30881L48.748 10.0113V19.8262C48.748 23.1498 50.5523 25.0565 53.6983 25.0565C56.8438 25.0565 58.648 23.1498 58.648 19.8262V19.4041H56.0904V19.826H56.0906Z"
              fill="#113050"
            />
          </g>
          <path
            d="M250.898 13.6148C250.898 13.3921 250.939 13.1822 251.02 12.9852C251.102 12.789 251.213 12.6176 251.354 12.4734C251.494 12.3285 251.658 12.2127 251.846 12.1281C252.035 12.0427 252.236 12.0002 252.449 12.0002C252.662 12.0002 252.862 12.0427 253.05 12.1281C253.238 12.2127 253.403 12.3285 253.543 12.4734C253.684 12.6176 253.795 12.7888 253.876 12.9852C253.958 13.1822 253.999 13.3921 253.999 13.6148C253.999 13.8383 253.958 14.0467 253.876 14.2409C253.795 14.436 253.684 14.6052 253.543 14.7494C253.403 14.8951 253.238 15.0086 253.05 15.092C252.862 15.174 252.662 15.2158 252.449 15.2158C252.236 15.2158 252.035 15.1737 251.846 15.092C251.658 15.0089 251.494 14.8951 251.354 14.7494C251.213 14.6052 251.102 14.436 251.02 14.2409C250.939 14.0467 250.898 13.8383 250.898 13.6148ZM251.143 13.6148C251.143 13.8003 251.177 13.9757 251.245 14.1415C251.313 14.3073 251.406 14.4535 251.524 14.5789C251.642 14.7049 251.78 14.8031 251.939 14.8742C252.098 14.9459 252.268 14.9811 252.45 14.9811C252.63 14.9811 252.801 14.9459 252.959 14.8742C253.118 14.8031 253.256 14.7049 253.374 14.5789C253.492 14.4537 253.585 14.3076 253.653 14.1415C253.721 13.9757 253.755 13.8003 253.755 13.6148C253.755 13.4251 253.721 13.2479 253.653 13.0813C253.585 12.9155 253.492 12.7705 253.374 12.6472C253.256 12.524 253.118 12.4265 252.959 12.3554C252.801 12.2844 252.63 12.2485 252.45 12.2485C252.268 12.2485 252.098 12.2844 251.939 12.3554C251.78 12.4265 251.642 12.524 251.524 12.6472C251.406 12.7705 251.313 12.9155 251.245 13.0813C251.177 13.2479 251.143 13.4254 251.143 13.6148ZM251.843 12.6976H252.456C252.537 12.6976 252.616 12.7071 252.693 12.7253C252.771 12.7443 252.84 12.7754 252.901 12.8179C252.962 12.8612 253.011 12.9155 253.047 12.9818C253.083 13.0482 253.102 13.1309 253.102 13.2311C253.102 13.3639 253.066 13.4721 252.993 13.5547C252.921 13.6379 252.823 13.6936 252.7 13.722L253.17 14.5189H252.789L252.381 13.758H252.156V14.5189H251.844L251.843 12.6976ZM252.408 13.4944C252.498 13.4944 252.585 13.4762 252.666 13.4409C252.748 13.4049 252.789 13.3332 252.789 13.2243C252.789 13.1248 252.751 13.0577 252.677 13.0246C252.601 12.9916 252.523 12.9753 252.441 12.9753H252.156V13.4944H252.408Z"
            fill="#0075C9"
          />
          <path
            d="M175.154 16.6826C175.154 11.7485 178.619 8.1239 183.526 8.1239C187.641 8.1239 190.745 10.6659 191.635 14.4165H188.387C187.641 12.4282 185.861 11.119 183.526 11.119C180.399 11.119 178.282 13.4606 178.282 16.6826C178.282 19.9045 180.399 22.2705 183.526 22.2705C185.861 22.2705 187.641 20.9368 188.387 18.9479H191.635C190.745 22.6992 187.641 25.2413 183.526 25.2413C178.619 25.2413 175.154 21.6159 175.154 16.6826Z"
            fill="#0075C9"
          />
          <path
            d="M193.582 17.6895C193.582 13.9389 195.699 12.1517 198.803 12.1517C201.907 12.1517 204 13.9389 204 17.7403V17.8155H201.161V17.6895C201.161 15.6754 200.198 14.9456 198.803 14.9456C197.408 14.9456 196.445 15.6754 196.445 17.6895V24.9137H193.582L193.582 17.6895Z"
            fill="#0075C9"
          />
          <path
            d="M214.778 17.3627C214.322 15.7007 213.022 14.87 211.458 14.87C209.846 14.87 208.595 15.7264 208.138 17.3627H214.778ZM205.059 18.6962C205.059 14.9206 207.706 12.1509 211.458 12.1509C215.212 12.1509 217.81 14.9206 217.81 18.6962V19.7537H208.066C208.451 21.5661 209.774 22.5227 211.458 22.5227C212.734 22.5227 213.672 22.1448 214.273 21.3392H217.329C216.438 23.7052 214.273 25.2408 211.458 25.2408C207.705 25.2408 205.059 22.4718 205.059 18.6962Z"
            fill="#0075C9"
          />
          <path
            d="M229.094 18.6965C229.094 16.5063 227.698 14.9459 225.606 14.9459C223.512 14.9459 222.092 16.5063 222.092 18.6965C222.092 20.8867 223.512 22.447 225.606 22.447C227.698 22.447 229.094 20.8867 229.094 18.6965ZM219.205 18.5705C219.205 14.3163 222.237 12.1512 225.124 12.1512C226.832 12.1512 228.251 12.9067 229.093 14.2913V7.04132H231.956V18.5956C231.956 22.6231 229.358 25.241 225.629 25.241C221.852 25.241 219.205 22.5222 219.205 18.5705Z"
            fill="#0075C9"
          />
          <path
            d="M234.723 12.4787H237.586V24.914H234.723V12.4787ZM234.266 8.87916C234.266 7.72072 235.06 6.86502 236.166 6.86502C237.273 6.86502 238.067 7.72072 238.067 8.87916C238.067 10.0369 237.273 10.8675 236.166 10.8675C235.06 10.8675 234.266 10.0366 234.266 8.87916Z"
            fill="#0075C9"
          />
          <path
            d="M240.352 20.1311V11.2267L243.215 8.07379V12.479H249.35V15.1971H243.215V20.1311C243.215 21.7924 244.033 22.447 245.212 22.447C246.39 22.447 247.208 21.8175 247.208 20.1311V19.8033H250.071V20.1311C250.071 23.5797 248.099 25.241 245.212 25.241C242.324 25.2412 240.352 23.5797 240.352 20.1311Z"
            fill="#0075C9"
          />
        </g>
        <defs>
          <clipPath id="clip0_858_15980">
            <rect width="254" height="31.8495" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export default StoneberryCreditIcon;
